module.exports = __webpack_public_path__ + "static/media/bandwidth_thumb_home_3.6bf66c57.jpg";